import Icon from '@ant-design/icons';

const AnalyticsIcon = props => (
  <Icon
    component={() => {
      return (
        <svg width='24' height='24' viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg'>
          <path
            d='M6.5 21H3C2.45 21 2 20.55 2 20V10C2 9.45 2.45 9 3 9H6.5C7.05 9 7.5 9.45 7.5 10V20C7.5 20.55 7.05 21 6.5 21ZM13.75 3H10.25C9.7 3 9.25 3.45 9.25 4V20C9.25 20.55 9.7 21 10.25 21H13.75C14.3 21 14.75 20.55 14.75 20V4C14.75 3.45 14.3 3 13.75 3ZM21 11H17.5C16.95 11 16.5 11.45 16.5 12V20C16.5 20.55 16.95 21 17.5 21H21C21.55 21 22 20.55 22 20V12C22 11.45 21.55 11 21 11Z'
            fill='#FFFFFF'
          />
        </svg>
      );
    }}
    {...props}
  />
);

const ContactsIcon = props => (
  <Icon
    component={() => {
      return (
        <svg width='24' height='24' viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg'>
          <path
            d='M19 0H5C4.45 0 4 0.45 4 1C4 1.55 4.45 2 5 2H19C19.55 2 20 1.55 20 1C20 0.45 19.55 0 19 0ZM5 24H19C19.55 24 20 23.55 20 23C20 22.45 19.55 22 19 22H5C4.45 22 4 22.45 4 23C4 23.55 4.45 24 5 24ZM20 4H4C2.9 4 2 4.9 2 6V18C2 19.1 2.9 20 4 20H20C21.1 20 22 19.1 22 18V6C22 4.9 21.1 4 20 4ZM12 6.75C13.24 6.75 14.25 7.76 14.25 9C14.25 10.24 13.24 11.25 12 11.25C10.76 11.25 9.75 10.24 9.75 9C9.75 7.76 10.76 6.75 12 6.75ZM17 17H7V15.5C7 13.83 10.33 13 12 13C13.67 13 17 13.83 17 15.5V17Z'
            fill='#FFFFFF'
          />
        </svg>
      );
    }}
    {...props}
  />
);

const ConsumersIcon = props => (
  <Icon
    component={() => {
      return (
        <svg width='24' height='24' viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg'>
          <path
            d='M21.6 3H15.6H15L14.4 3.00004L13.8 3H10.8H8.4H2.4C1.08 3 0 4.02 0 5.26667V17.7333C0 18.98 1.08 20 2.4 20H21.6C22.92 20 24 18.98 24 17.7333V5.26667C24 4.02 22.92 3 21.6 3ZM7.8 7.53333C8.796 7.53333 9.6 8.29267 9.6 9.23333C9.6 10.174 8.796 10.9333 7.8 10.9333C6.804 10.9333 6 10.174 6 9.23333C6 8.29267 6.804 7.53333 7.8 7.53333ZM11.4 13.8333C11.4 14.1095 11.1761 14.3333 10.9 14.3333H4.7C4.42386 14.3333 4.2 14.1095 4.2 13.8333V13.4833C4.2 12.35 6.6 11.7833 7.8 11.7833C9 11.7833 11.4 12.35 11.4 13.4833V13.8333ZM20.4 12.9167C20.4 13.3861 20.0194 13.7667 19.55 13.7667H15.25C14.7806 13.7667 14.4 13.3861 14.4 12.9167V12.9167C14.4 12.4472 14.7806 12.0667 15.25 12.0667H19.55C20.0194 12.0667 20.4 12.4472 20.4 12.9167V12.9167ZM20.4 9.51667C20.4 9.98611 20.0194 10.3667 19.55 10.3667H15.25C14.7806 10.3667 14.4 9.98611 14.4 9.51667V9.51667C14.4 9.04722 14.7806 8.66667 15.25 8.66667H19.55C20.0194 8.66667 20.4 9.04722 20.4 9.51667V9.51667Z'
            fill='#FFFFFF'
          />
        </svg>
      );
    }}
    {...props}
  />
);

const LeadsIcon = props => (
  <Icon
    component={() => {
      return (
        <svg width='24' height='24' viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg'>
          <path
            d='M16.5 12C17.88 12 18.99 10.88 18.99 9.5C18.99 8.12 17.88 7 16.5 7C15.12 7 14 8.12 14 9.5C14 10.88 15.12 12 16.5 12ZM9 11C10.66 11 11.99 9.66 11.99 8C11.99 6.34 10.66 5 9 5C7.34 5 6 6.34 6 8C6 9.66 7.34 11 9 11ZM16.5 14C14.67 14 11 14.92 11 16.75V18C11 18.55 11.45 19 12 19H21C21.55 19 22 18.55 22 18V16.75C22 14.92 18.33 14 16.5 14ZM9 13C6.67 13 2 14.17 2 16.5V18C2 18.55 2.45 19 3 19H9V16.75C9 15.9 9.33 14.41 11.37 13.28C10.5 13.1 9.66 13 9 13Z'
            fill='#FFFFFF'
          />
        </svg>
      );
    }}
    {...props}
  />
);

const LogoIcon = props => (
  <Icon
    component={() => {
      return (
        <svg width='48' height='48' viewBox='0 0 48 48' fill='none' xmlns='http://www.w3.org/2000/svg'>
          <rect width='48' height='48' rx='8' fill='#2951A3' />
          <path
            fillRule='evenodd'
            clipRule='evenodd'
            d='M23.4159 9.6001V12.1309C19.2078 12.4416 15.8416 16.0323 15.5872 20.4974H13.1992C13.459 14.6391 17.8936 9.91951 23.4159 9.6001ZM35.2044 20.4974H32.8163C32.5623 16.0323 29.1956 12.4416 24.9877 12.1309V9.6001C30.5103 9.91951 34.9451 14.6391 35.2044 20.4974ZM23.1938 33.3346L24.5458 31.6691L24.5468 31.6706C25.0485 31.0537 25.6452 30.3249 26.2517 29.5842L26.2524 29.5833L26.2525 29.5832C27.7631 27.7382 29.3336 25.8199 29.6451 25.3763L29.6757 25.3327C30.3229 24.4098 31.1711 23.2 31.2659 21.3658C31.2709 21.2485 31.2749 21.1307 31.2749 21.0113C31.2749 17.2952 28.1994 14.2704 24.419 14.2704C20.6396 14.2704 17.5636 17.2952 17.5636 21.0113C17.5636 21.1307 17.5671 21.2485 17.5731 21.3658C17.6689 23.2291 18.493 24.5667 19.1949 25.3763L19.239 25.4286L19.2435 25.4266C20.0641 26.356 21.1369 27.0591 22.3561 27.4402L23.8886 25.5494L22.5418 24.9042L22.5351 24.9005C20.9996 24.0485 20.1313 22.8544 20.0446 21.2381C20.0411 21.1642 20.0386 21.0887 20.0386 21.0113C20.0386 18.6363 22.0052 16.7041 24.419 16.7041C26.8343 16.7041 28.8009 18.6363 28.8009 21.0113C28.8009 21.0887 28.7979 21.1642 28.7944 21.2381C28.7428 22.2075 28.4355 22.8662 27.7662 23.7877C27.0965 24.7087 21.6042 31.39 21.6042 31.39C21.2369 30.938 20.8661 30.4834 20.505 30.0407L20.5048 30.0405C19.3541 28.6298 18.3019 27.3399 17.7777 26.64C16.4858 24.9168 15.809 23.4578 15.6792 21.7051H13.1992C13.3301 24.0179 14.1958 25.9477 15.816 28.1241C16.6055 29.1851 18.5195 31.5196 20.2294 33.6051L20.2295 33.6052L20.2299 33.6057C20.7152 34.1977 21.1841 34.7696 21.6062 35.2866L23.1908 33.3385C23.1908 33.3385 23.1923 33.3361 23.1938 33.3346ZM22.5361 24.9015C22.5361 24.9015 23.1948 25.2663 22.5418 24.9042L22.5361 24.9015ZM27.2478 30.6524C28.6677 28.8734 30.0783 27.106 30.7084 26.2406C31.9999 24.4676 32.6427 23.0398 32.7677 21.2758H35.2044C35.0754 23.6032 34.2417 25.5032 32.6343 27.7334C31.2673 29.6308 26.4598 35.5758 25.3542 36.9429C25.2342 37.0913 25.1578 37.1858 25.1342 37.2153L24.1877 38.4001L23.2423 37.2153C23.197 37.1607 22.9745 36.882 22.63 36.4501L24.1877 34.4936C24.6423 33.9249 25.2244 33.1927 25.8578 32.3961L25.9433 32.2886L25.9452 32.2866C26.3649 31.7586 26.8068 31.2049 27.2478 30.6524Z'
            fill='white'
          />
        </svg>
      );
    }}
    {...props}
  />
);

const LogoWhiteIcon = props => (
  <Icon
    component={() => {
      return (
        <svg width='40' height='40' viewBox='0 0 40 40' fill='none' xmlns='http://www.w3.org/2000/svg'>
          <rect width='40' height='40' rx='8' fill='white' />
          <rect width='24' height='24' transform='translate(8 8)' fill='white' />
          <path
            fillRule='evenodd'
            clipRule='evenodd'
            d='M19.5139 8V10.109C16.0071 10.3679 13.202 13.3602 12.99 17.0811H11C11.2165 12.1992 14.9119 8.26618 19.5139 8ZM29.3376 17.0811H27.3476C27.1359 13.3602 24.3303 10.3679 20.8237 10.109V8C25.4259 8.26618 29.1216 12.1992 29.3376 17.0811ZM19.3288 27.7788L20.4555 26.3908L20.4563 26.3921C20.8746 25.8778 21.3721 25.2702 21.8776 24.6527C23.1365 23.1151 24.4453 21.5165 24.7049 21.1468L24.7304 21.1105C25.2697 20.3414 25.9766 19.3333 26.0555 17.8048C26.0597 17.707 26.0631 17.6088 26.0631 17.5094C26.0631 14.4126 23.5001 11.8919 20.3498 11.8919C17.2003 11.8919 14.637 14.4126 14.637 17.5094C14.637 17.6088 14.6399 17.707 14.6449 17.8048C14.7247 19.3575 15.4115 20.4722 15.9964 21.1468L16.0331 21.1904L16.0369 21.1887C16.7208 21.9632 17.6148 22.5491 18.6307 22.8668L19.9078 21.291L18.7855 20.7534L18.7799 20.7503C17.5003 20.0403 16.7767 19.0452 16.7045 17.6984C16.7015 17.6367 16.6995 17.5739 16.6995 17.5094C16.6995 15.5302 18.3383 13.92 20.3498 13.92C22.3626 13.92 24.0014 15.5302 24.0014 17.5094C24.0014 17.5739 23.9989 17.6367 23.996 17.6984C23.953 18.5061 23.6969 19.0551 23.1392 19.823C22.5811 20.5905 18.0041 26.1583 18.0041 26.1583C17.6981 25.7816 17.389 25.4027 17.0881 25.0338L17.088 25.0336C16.1291 23.8581 15.2522 22.7831 14.8154 22.1999C13.7388 20.7639 13.1748 19.5481 13.0666 18.0875H11C11.109 20.0149 11.8305 21.623 13.1807 23.4366C13.8386 24.3208 15.4336 26.2662 16.8585 28.0042L16.8586 28.0043C17.2631 28.4977 17.654 28.9745 18.0058 29.4054L19.3263 27.782C19.3263 27.782 19.3276 27.78 19.3288 27.7788ZM18.7807 20.7512C18.7807 20.7512 19.3297 21.0552 18.7855 20.7534L18.7807 20.7512ZM22.7072 25.5435C23.8904 24.0611 25.0659 22.5883 25.591 21.8671C26.6672 20.3896 27.2029 19.1998 27.307 17.7297H29.3376C29.2302 19.6693 28.5354 21.2526 27.1959 23.1111C26.0567 24.6923 22.0502 29.6467 21.1291 30.7858C21.0291 30.9094 20.9655 30.9881 20.9458 31.0127L20.1571 32L19.3692 31.0127C19.3315 30.9672 19.1461 30.7349 18.859 30.375L20.1571 28.7446C20.5357 28.2709 21.0206 27.6611 21.5481 26.9976L21.62 26.9071L21.6217 26.9055C21.9714 26.4654 22.3397 26.004 22.7072 25.5435Z'
            fill='#254993'
          />
        </svg>
      );
    }}
    {...props}
  />
);

const OpportunitiesIcon = props => (
  <Icon
    component={() => {
      return (
        <svg width='24' height='24' viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg'>
          <path
            d='M11.99 2C6.47 2 2 6.48 2 12C2 17.52 6.47 22 11.99 22C17.52 22 22 17.52 22 12C22 6.48 17.52 2 11.99 2ZM15.22 17.39L12 15.45L8.78 17.39C8.4 17.62 7.93 17.28 8.03 16.85L8.88 13.19L6.05 10.74C5.72 10.45 5.9 9.9 6.34 9.86L10.08 9.54L11.54 6.09C11.71 5.68 12.29 5.68 12.46 6.09L13.92 9.53L17.66 9.85C18.1 9.89 18.28 10.44 17.94 10.73L15.11 13.18L15.96 16.85C16.06 17.28 15.6 17.62 15.22 17.39Z'
            fill='#FFFFFF'
          />
        </svg>
      );
    }}
    {...props}
  />
);

const SettingsIcon = props => (
  <Icon
    component={() => {
      return (
        <svg width='24' height='24' viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg'>
          <path
            d='M19.14 12.936C19.176 12.636 19.2 12.324 19.2 12C19.2 11.676 19.176 11.364 19.128 11.064L21.156 9.48C21.336 9.336 21.384 9.072 21.276 8.868L19.356 5.544C19.236 5.328 18.984 5.256 18.768 5.328L16.38 6.288C15.876 5.904 15.348 5.592 14.76 5.352L14.4 2.808C14.364 2.568 14.16 2.4 13.92 2.4H10.08C9.83998 2.4 9.64799 2.568 9.61199 2.808L9.25199 5.352C8.66399 5.592 8.12399 5.916 7.63199 6.288L5.24398 5.328C5.02798 5.244 4.77598 5.328 4.65598 5.544L2.73598 8.868C2.61598 9.084 2.66398 9.336 2.85598 9.48L4.88398 11.064C4.83598 11.364 4.79998 11.688 4.79998 12C4.79998 12.312 4.82398 12.636 4.87198 12.936L2.84398 14.52C2.66398 14.664 2.61598 14.928 2.72398 15.132L4.64398 18.456C4.76398 18.672 5.01598 18.744 5.23198 18.672L7.61998 17.712C8.12398 18.096 8.65198 18.408 9.23998 18.648L9.59999 21.192C9.64799 21.432 9.83998 21.6 10.08 21.6H13.92C14.16 21.6 14.364 21.432 14.388 21.192L14.748 18.648C15.336 18.408 15.876 18.084 16.368 17.712L18.756 18.672C18.972 18.756 19.224 18.672 19.344 18.456L21.264 15.132C21.384 14.916 21.336 14.664 21.144 14.52L19.14 12.936V12.936ZM12 15.6C10.02 15.6 8.39998 13.98 8.39998 12C8.39998 10.02 10.02 8.4 12 8.4C13.98 8.4 15.6 10.02 15.6 12C15.6 13.98 13.98 15.6 12 15.6Z'
            fill='#FFFFFF'
          />
        </svg>
      );
    }}
    {...props}
  />
);

const AccountIcon = props => (
  <Icon
    component={() => {
      return (
        <svg width='24' height='24' viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg'>
          <path
            d='M3 5V19C3 20.1 3.89 21 5 21H19C20.1 21 21 20.1 21 19V5C21 3.9 20.1 3 19 3H5C3.89 3 3 3.9 3 5ZM15 9C15 10.66 13.66 12 12 12C10.34 12 9 10.66 9 9C9 7.34 10.34 6 12 6C13.66 6 15 7.34 15 9ZM6 17C6 15 10 13.9 12 13.9C14 13.9 18 15 18 17V18H6V17Z'
            fill='#FFFFFF'
          />
        </svg>
      );
    }}
    {...props}
  />
);

const RoleIcon = props => (
  <Icon
    component={() => {
      return (
        <svg width='24' height='24' viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg'>
          <path
            d='M12.3566 5.42452C10.8418 3.91457 8.57346 3.60657 6.74974 4.49301L9.48533 7.21993C9.77923 7.5129 9.77923 7.98617 9.48533 8.27914L8.2871 9.47358C7.99319 9.77406 7.51842 9.77406 7.22451 9.47358L4.48893 6.74666C3.60721 8.57212 3.91619 10.8183 5.43093 12.3282C6.83264 13.7255 8.88244 14.0936 10.6233 13.44L16.622 19.4197C17.3982 20.1934 18.6492 20.1934 19.4178 19.4197C20.1941 18.6459 20.1941 17.3989 19.4178 16.6327L13.4493 10.6755C14.1426 8.91768 13.7809 6.84432 12.3566 5.42452Z'
            fill='#FFFFFF'
          />
        </svg>
      );
    }}
    {...props}
  />
);

const MenuIcon = props => (
  <Icon
    component={() => {
      return (
        <svg width='24' height='24' viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg'>
          <path
            d='M20 7V19C20 19.55 19.55 20 19 20H7C6.45 20 6 20.45 6 21C6 21.55 6.45 22 7 22H20C21.1 22 22 21.1 22 20V7C22 6.45 21.55 6 21 6C20.45 6 20 6.45 20 7Z'
            fill='#FFFFFF'
          />
          <path
            d='M16 2H4C2.9 2 2 2.9 2 4V16C2 17.1 2.9 18 4 18H16C17.1 18 18 17.1 18 16V4C18 2.9 17.1 2 16 2ZM9 16H4V11H9V16ZM16 16H11V11H16V16ZM16 9H4V4H16V9Z'
            fill='#FFFFFF'
          />
        </svg>
      );
    }}
    {...props}
  />
);

const PersonIcon = props => (
  <Icon
    component={() => {
      return (
        <svg
          width={props.size ? props.size : 24}
          height={props.size ? props.size : 24}
          viewBox='0 0 24 24'
          fill='none'
          xmlns='http://www.w3.org/2000/svg'
        >
          <path
            d='M12 12C14.21 12 16 10.21 16 8C16 5.79 14.21 4 12 4C9.79 4 8 5.79 8 8C8 10.21 9.79 12 12 12ZM12 14C9.33 14 4 15.34 4 18V19C4 19.55 4.45 20 5 20H19C19.55 20 20 19.55 20 19V18C20 15.34 14.67 14 12 14Z'
            fill={props.color ? props.color : '#FFFFFF'}
          />
        </svg>
      );
    }}
    {...props}
  />
);

const ExpandMoreIcon = props => (
  <Icon
    component={() => {
      return (
        <svg
          width={props.size ? props.size : '16'}
          height={props.size ? props.size : '16'}
          viewBox='0 0 24 24'
          fill='none'
          xmlns='http://www.w3.org/2000/svg'
        >
          <path
            d='M15.88 9.29L12 13.17L8.12 9.29C7.73 8.9 7.1 8.9 6.71 9.29C6.32 9.68 6.32 10.31 6.71 10.7L11.3 15.29C11.69 15.68 12.32 15.68 12.71 15.29L17.3 10.7C17.69 10.31 17.69 9.68 17.3 9.29C16.91 8.91 16.27 8.9 15.88 9.29Z'
            fill={props.color ? props.color : '#FFFFFF'}
          />
        </svg>
      );
    }}
    {...props}
  />
);

const ExpandLessIcon = props => (
  <Icon
    component={() => {
      return (
        <svg
          width={props.size ? props.size : '16'}
          height={props.size ? props.size : '16'}
          viewBox='0 0 24 24'
          fill='none'
          xmlns='http://www.w3.org/2000/svg'
        >
          <path
            d='M11.29 8.71L6.7 13.3C6.31 13.69 6.31 14.32 6.7 14.71C7.09 15.1 7.72 15.1 8.11 14.71L12 10.83L15.88 14.71C16.27 15.1 16.9 15.1 17.29 14.71C17.68 14.32 17.68 13.69 17.29 13.3L12.7 8.71C12.32 8.32 11.68 8.32 11.29 8.71Z'
            fill={props.color ? props.color : '#FFFFFF'}
          />
        </svg>
      );
    }}
    {...props}
  />
);

const ColumnIcon = props => (
  <Icon
    component={() => {
      return (
        <svg
          width={props.size ? props.size : '24'}
          height={props.size ? props.size : '24'}
          viewBox='0 0 24 24'
          fill='none'
          xmlns='http://www.w3.org/2000/svg'
        >
          <path
            d='M10 10.02H15V21H10V10.02ZM17 21H20C21.1 21 22 20.1 22 19V10H17V21ZM20 3H5C3.9 3 3 3.9 3 5V8H22V5C22 3.9 21.1 3 20 3ZM3 19C3 20.1 3.9 21 5 21H8V10H3V19Z'
            fill={props.color ? props.color : '#FFFFFF'}
          />
        </svg>
      );
    }}
    {...props}
  />
);

const FilterIcon = props => (
  <Icon
    component={() => {
      return (
        <svg
          width={props.size ? props.size : '24'}
          height={props.size ? props.size : '24'}
          viewBox='0 0 24 24'
          fill='none'
          xmlns='http://www.w3.org/2000/svg'
        >
          <path
            d='M3 9C3 9.55 3.45 10 4 10H13V8H4C3.45 8 3 8.45 3 9ZM7 13V14H4C3.45 14 3 14.45 3 15C3 15.55 3.45 16 4 16H7V17C7 17.55 7.45 18 8 18C8.55 18 9 17.55 9 17V13C9 12.45 8.55 12 8 12C7.45 12 7 12.45 7 13ZM21 15C21 14.45 20.55 14 20 14H11V16H20C20.55 16 21 15.55 21 15ZM16 12C16.55 12 17 11.55 17 11V10H20C20.55 10 21 9.55 21 9C21 8.45 20.55 8 20 8H17V7C17 6.45 16.55 6 16 6C15.45 6 15 6.45 15 7V11C15 11.55 15.45 12 16 12Z'
            fill={props.color ? props.color : '#FFFFFF'}
          />
        </svg>
      );
    }}
    {...props}
  />
);

const CallIcon = props => (
  <Icon
    component={() => {
      return (
        <svg
          width={props.size ? props.size : '24'}
          height={props.size ? props.size : '24'}
          viewBox='0 0 24 24'
          fill='none'
          xmlns='http://www.w3.org/2000/svg'
        >
          <path
            d='M7.21778 10.9244C8.49778 13.44 10.56 15.4933 13.0756 16.7822L15.0311 14.8267C15.2711 14.5867 15.6267 14.5067 15.9378 14.6133C16.9333 14.9422 18.0089 15.12 19.1111 15.12C19.6 15.12 20 15.52 20 16.0089V19.1111C20 19.6 19.6 20 19.1111 20C10.7644 20 4 13.2356 4 4.88889C4 4.4 4.4 4 4.88889 4H8C8.48889 4 8.88889 4.4 8.88889 4.88889C8.88889 6 9.06667 7.06667 9.39556 8.06222C9.49333 8.37333 9.42222 8.72 9.17333 8.96889L7.21778 10.9244Z'
            fill={props.color ? props.color : '#FFFFFF'}
          />
          <mask id='mask0_3_4113' maskUnits='userSpaceOnUse' x='4' y='4' width='16' height='16'>
            <path
              d='M7.21778 10.9244C8.49778 13.44 10.56 15.4933 13.0756 16.7822L15.0311 14.8267C15.2711 14.5867 15.6267 14.5067 15.9378 14.6133C16.9333 14.9422 18.0089 15.12 19.1111 15.12C19.6 15.12 20 15.52 20 16.0089V19.1111C20 19.6 19.6 20 19.1111 20C10.7644 20 4 13.2356 4 4.88889C4 4.4 4.4 4 4.88889 4H8C8.48889 4 8.88889 4.4 8.88889 4.88889C8.88889 6 9.06667 7.06667 9.39556 8.06222C9.49333 8.37333 9.42222 8.72 9.17333 8.96889L7.21778 10.9244Z'
              fill={props.color ? props.color : '#FFFFFF'}
            />
          </mask>
          <g mask='url(#mask0_3_4113)'>
            <rect width='24' height='24' fill={props.color ? props.color : '#FFFFFF'} />
          </g>
        </svg>
      );
    }}
    {...props}
  />
);

const WhatsAppIcon = props => (
  <Icon
    component={() => {
      return (
        <svg
          width={props.size ? props.size : '24'}
          height={props.size ? props.size : '24'}
          viewBox='0 0 24 24'
          fill='none'
          xmlns='http://www.w3.org/2000/svg'
        >
          <path
            fillRule='evenodd'
            clipRule='evenodd'
            d='M12 3C14.3869 3 16.6761 3.94821 18.364 5.63604C20.0518 7.32387 21 9.61305 21 12C21 16.9706 16.9706 21 12 21C10.227 21 8.58 20.487 7.185 19.605L3 21L4.395 16.815C3.513 15.42 3 13.773 3 12C3 7.02944 7.02944 3 12 3ZM16.275 13.764C16.3062 13.7802 16.3358 13.7954 16.3638 13.8097C16.538 13.899 16.6502 13.9565 16.689 14.034C16.743 14.133 16.725 14.583 16.5 15.096C16.32 15.6 15.384 16.086 14.97 16.104C14.8973 16.1072 14.8371 16.1192 14.7752 16.1316C14.4841 16.1898 14.1537 16.2558 12.306 15.447C10.246 14.5452 8.93886 12.4495 8.65728 11.998C8.63254 11.9583 8.61572 11.9314 8.607 11.919C8.499 11.766 7.743 10.677 7.779 9.57C7.8236 8.48177 8.38979 7.95933 8.62767 7.73984L8.634 7.734C8.85 7.5 9.093 7.473 9.246 7.5H9.669C9.68146 7.5 9.69437 7.49954 9.70769 7.49907C9.83872 7.4944 10.0088 7.48835 10.164 7.905L10.785 9.588C10.839 9.705 10.875 9.84 10.794 9.984L10.551 10.353L10.2 10.731L10.1921 10.7389C10.086 10.8448 9.96907 10.9615 10.092 11.181C10.2 11.415 10.65 12.162 11.28 12.783C11.9663 13.4467 12.5831 13.7375 12.8921 13.8832L12.8921 13.8832C12.9518 13.9113 13 13.9341 13.035 13.953C13.251 14.079 13.386 14.061 13.521 13.917L14.25 13.071C14.4187 12.849 14.5611 12.8986 14.7637 12.9691L14.772 12.972L16.275 13.764ZM4.8 12C4.8 8.02355 8.02355 4.8 12 4.8C15.9764 4.8 19.2 8.02355 19.2 12C19.2 15.9764 15.9764 19.2 12 19.2C10.452 19.2 9.021 18.714 7.851 17.886L5.25 18.75L6.114 16.149C5.286 14.979 4.8 13.548 4.8 12Z'
            fill={props.color ? props.color : '#FFFFFF'}
          />
        </svg>
      );
    }}
    {...props}
  />
);

const MoreIcon = props => (
  <Icon
    component={() => {
      return (
        <svg
          width={props.size ? props.size : '24'}
          height={props.size ? props.size : '24'}
          viewBox='0 0 24 24'
          fill='none'
          xmlns='http://www.w3.org/2000/svg'
        >
          <path
            d='M12 8C13.1 8 14 7.1 14 6C14 4.9 13.1 4 12 4C10.9 4 10 4.9 10 6C10 7.1 10.9 8 12 8ZM12 10C10.9 10 10 10.9 10 12C10 13.1 10.9 14 12 14C13.1 14 14 13.1 14 12C14 10.9 13.1 10 12 10ZM12 16C10.9 16 10 16.9 10 18C10 19.1 10.9 20 12 20C13.1 20 14 19.1 14 18C14 16.9 13.1 16 12 16Z'
            fill={props.color ? props.color : '#FFFFFF'}
          />
        </svg>
      );
    }}
    {...props}
  />
);

const PermissionIcon = props => (
  <Icon
    component={() => {
      return (
        <svg
          width={props.size ? props.size : '24'}
          height={props.size ? props.size : '24'}
          viewBox='0 0 24 24'
          fill='none'
          xmlns='http://www.w3.org/2000/svg'
        >
          <path
            d='M12 20L11.14 19.14C9.96 17.96 9.97 16.04 11.16 14.88L12 14.06C11.61 14.02 11.32 14 11 14C8.33 14 3 15.34 3 18V20H12ZM11 12C13.21 12 15 10.21 15 8C15 5.79 13.21 4 11 4C8.79 4 7 5.79 7 8C7 10.21 8.79 12 11 12Z'
            fill={props.color ? props.color : '#FFFFFF'}
          />
          <path
            d='M16.18 19.78C15.79 20.17 15.15 20.17 14.76 19.78L12.69 17.69C12.31 17.3 12.31 16.68 12.69 16.3L12.7 16.29C13.09 15.9 13.72 15.9 14.1 16.29L15.47 17.66L19.9 13.2C20.29 12.81 20.92 12.81 21.31 13.2L21.32 13.21C21.7 13.6 21.7 14.22 21.32 14.6L16.18 19.78Z'
            fill={props.color ? props.color : '#FFFFFF'}
          />
        </svg>
      );
    }}
    {...props}
  />
);

const EditIcon = props => (
  <Icon
    component={() => {
      return (
        <svg
          width={props.size ? props.size : '16'}
          height={props.size ? props.size : '16'}
          viewBox='0 0 16 16'
          fill='none'
          xmlns='http://www.w3.org/2000/svg'
        >
          <path
            d='M14.1627 4.00493L13.7662 4.40143L11.5512 2.18743L11.9477 1.79043C12.3192 1.41893 12.7562 1.33193 12.9782 1.55343L14.3997 2.97493C14.6207 3.19693 14.5337 3.63443 14.1627 4.00543V4.00493ZM2.6332 11.5859L4.3677 13.3194L2.0557 13.8969L2.6332 11.5859ZM5.2367 12.9309L3.0217 10.7169L10.9232 2.81543L13.1372 5.03043L5.2367 12.9309ZM15.0282 2.34593L13.6067 0.92443C12.9722 0.28993 11.9977 0.48393 11.3197 1.16143L2.0792 10.4019C2.0257 10.4554 1.9947 10.5199 1.9742 10.5874C1.9717 10.5954 1.9642 10.6009 1.9617 10.6079L1.0147 14.3994C0.933201 14.7244 1.2277 15.0194 1.5532 14.9379L5.3447 13.9909C5.3527 13.9884 5.3582 13.9809 5.3652 13.9784C5.4327 13.9579 5.4977 13.9269 5.5507 13.8734L14.7912 4.63293C15.4692 3.95493 15.6627 2.98143 15.0282 2.34593Z'
            fill={props.color ? props.color : '#FFFFFF'}
          />
        </svg>
      );
    }}
    {...props}
  />
);

const DragIcon = props => (
  <Icon
    component={() => {
      return (
        <svg
          width={props.size ? props.size : '24'}
          height={props.size ? props.size : '24'}
          viewBox='0 0 24 24'
          fill='none'
          xmlns='http://www.w3.org/2000/svg'
        >
          <path
            d='M11 18C11 19.1 10.1 20 9 20C7.9 20 7 19.1 7 18C7 16.9 7.9 16 9 16C10.1 16 11 16.9 11 18ZM9 10C7.9 10 7 10.9 7 12C7 13.1 7.9 14 9 14C10.1 14 11 13.1 11 12C11 10.9 10.1 10 9 10ZM9 4C7.9 4 7 4.9 7 6C7 7.1 7.9 8 9 8C10.1 8 11 7.1 11 6C11 4.9 10.1 4 9 4ZM15 8C16.1 8 17 7.1 17 6C17 4.9 16.1 4 15 4C13.9 4 13 4.9 13 6C13 7.1 13.9 8 15 8ZM15 10C13.9 10 13 10.9 13 12C13 13.1 13.9 14 15 14C16.1 14 17 13.1 17 12C17 10.9 16.1 10 15 10ZM15 16C13.9 16 13 16.9 13 18C13 19.1 13.9 20 15 20C16.1 20 17 19.1 17 18C17 16.9 16.1 16 15 16Z'
            fill={props.color ? props.color : '#FFFFFF'}
          />
        </svg>
      );
    }}
    {...props}
  />
);

const DropUpIcon = props => (
  <Icon
    component={() => {
      return (
        <svg
          width={props.size ? props.size : '8'}
          height={props.size ? props.size - 3 : '5'}
          viewBox='0 0 8 5'
          fill='none'
          xmlns='http://www.w3.org/2000/svg'
        >
          <path
            d='M0.710006 3.29L3.30001 0.700001C3.69001 0.310001 4.32001 0.310001 4.71001 0.700001L7.30001 3.29C7.93001 3.92 7.48001 5 6.59001 5H1.41001C0.520006 5 0.0800057 3.92 0.710006 3.29Z'
            fill={props.color ? props.color : '#FFFFFF'}
          />
        </svg>
      );
    }}
    {...props}
  />
);

const DropDownIcon = props => (
  <Icon
    component={() => {
      return (
        <svg
          width={props.size ? props.size : '8'}
          height={props.size ? props.size - 3 : '5'}
          viewBox='0 0 8 5'
          fill='none'
          xmlns='http://www.w3.org/2000/svg'
        >
          <path
            d='M0.709998 1.71L3.3 4.3C3.69 4.69 4.32 4.69 4.71 4.3L7.3 1.71C7.93 1.08 7.48 0 6.59 0H1.41C0.519998 0 0.079998 1.08 0.709998 1.71Z'
            fill={props.color ? props.color : '#FFFFFF'}
          />
        </svg>
      );
    }}
    {...props}
  />
);

const CheckFilledIcon = props => (
  <Icon
    component={() => {
      return (
        <svg
          width={props.size ? props.size : '16'}
          height={props.size ? props.size : '16'}
          viewBox='0 0 16 16'
          fill='none'
          xmlns='http://www.w3.org/2000/svg'
        >
          <path
            d='M16 8C16 10.1217 15.1571 12.1566 13.6569 13.6569C12.1566 15.1571 10.1217 16 8 16C5.87827 16 3.84344 15.1571 2.34315 13.6569C0.842855 12.1566 0 10.1217 0 8C0 5.87827 0.842855 3.84344 2.34315 2.34315C3.84344 0.842855 5.87827 0 8 0C10.1217 0 12.1566 0.842855 13.6569 2.34315C15.1571 3.84344 16 5.87827 16 8V8ZM12.03 4.97C11.9586 4.89882 11.8735 4.84277 11.7799 4.80522C11.6863 4.76766 11.5861 4.74936 11.4853 4.75141C11.3845 4.75347 11.2851 4.77583 11.1932 4.81717C11.1012 4.85851 11.0185 4.91797 10.95 4.992L7.477 9.417L5.384 7.323C5.24182 7.19052 5.05378 7.1184 4.85948 7.12183C4.66518 7.12525 4.47979 7.20397 4.34238 7.34138C4.20497 7.47879 4.12625 7.66418 4.12283 7.85848C4.1194 8.05278 4.19152 8.24083 4.324 8.383L6.97 11.03C7.04128 11.1012 7.12616 11.1572 7.21958 11.1949C7.313 11.2325 7.41305 11.2509 7.51375 11.2491C7.61444 11.2472 7.71374 11.2251 7.8057 11.184C7.89766 11.1429 7.9804 11.0837 8.049 11.01L12.041 6.02C12.1771 5.8785 12.2523 5.68928 12.2504 5.49296C12.2485 5.29664 12.1698 5.10888 12.031 4.97H12.03Z'
            fill={props.color ? props.color : '#000000'}
          />
        </svg>
      );
    }}
    {...props}
  />
);

const CheckIcon = props => (
  <Icon
    component={() => {
      return (
        <svg
          width={props.size ? props.size : '16'}
          height={props.size ? props.size : '16'}
          viewBox='0 0 24 24'
          fill='none'
          xmlns='http://www.w3.org/2000/svg'
        >
          <path
            d='M9.00001 16.17L5.53001 12.7C5.14002 12.31 4.51001 12.31 4.12001 12.7C3.73001 13.09 3.73001 13.72 4.12001 14.11L8.30001 18.29C8.69001 18.68 9.32001 18.68 9.71001 18.29L20.29 7.71C20.68 7.32 20.68 6.69 20.29 6.3C19.9 5.91 19.27 5.91 18.88 6.3L9.00001 16.17Z'
            fill={props.color ? props.color : '#000000'}
          />
        </svg>
      );
    }}
    {...props}
  />
);

const CloseIcon = props => (
  <Icon
    component={() => {
      return (
        <svg
          width={props.size ? props.size : '16'}
          height={props.size ? props.size : '16'}
          viewBox='0 0 24 24'
          fill='none'
          xmlns='http://www.w3.org/2000/svg'
        >
          <path
            d='M18.3 5.71C17.91 5.32 17.28 5.32 16.89 5.71L12 10.59L7.10997 5.7C6.71997 5.31 6.08997 5.31 5.69997 5.7C5.30997 6.09 5.30997 6.72 5.69997 7.11L10.59 12L5.69997 16.89C5.30997 17.28 5.30997 17.91 5.69997 18.3C6.08997 18.69 6.71997 18.69 7.10997 18.3L12 13.41L16.89 18.3C17.28 18.69 17.91 18.69 18.3 18.3C18.69 17.91 18.69 17.28 18.3 16.89L13.41 12L18.3 7.11C18.68 6.73 18.68 6.09 18.3 5.71Z'
            fill={props.color ? props.color : '#000000'}
          />
        </svg>
      );
    }}
    {...props}
  />
);

const ExpandableDownIcon = props => (
  <Icon
    component={() => {
      return (
        <svg
          width={props.size ? props.size : '16'}
          height={props.size ? props.size : '16'}
          viewBox='0 0 16 16'
          fill='none'
          xmlns='http://www.w3.org/2000/svg'
        >
          <path
            d='M2.45574 5.72012L7.87774 10.9251C8.07124 11.1111 8.37724 11.1111 8.57074 10.9251L13.9927 5.72012C14.1922 5.52862 14.1987 5.21162 14.0072 5.01262C13.8157 4.81362 13.4987 4.80662 13.2997 4.99812L7.87774 10.2031H8.57074L3.14874 4.99812C2.94924 4.80662 2.63274 4.81312 2.44124 5.01262C2.24974 5.21212 2.25624 5.52862 2.45574 5.72012Z'
            fill={props.color ? props.color : '#000000'}
          />
        </svg>
      );
    }}
    {...props}
  />
);

const ExpandableUpIcon = props => (
  <Icon
    component={() => {
      return (
        <svg
          width={props.size ? props.size : '16'}
          height={props.size ? props.size : '16'}
          viewBox='0 0 16 16'
          fill='none'
          xmlns='http://www.w3.org/2000/svg'
        >
          <path
            d='M3.14874 10.9249L8.57074 5.7199H7.87774L13.2997 10.9249C13.4992 11.1164 13.8157 11.1099 14.0072 10.9104C14.1987 10.7109 14.1922 10.3944 13.9927 10.2029L8.57074 4.9979C8.37724 4.8119 8.07124 4.8119 7.87774 4.9979L2.45574 10.2029C2.25624 10.3944 2.24974 10.7114 2.44124 10.9104C2.63274 11.1094 2.94924 11.1164 3.14874 10.9249Z'
            fill={props.color ? props.color : '#000000'}
          />
        </svg>
      );
    }}
    {...props}
  />
);

const DownloadIcon = props => (
  <Icon
    component={() => {
      return (
        <svg
          width={props.size ? props.size : '24'}
          height={props.size ? props.size : '24'}
          viewBox='0 0 24 24'
          fill='none'
          xmlns='http://www.w3.org/2000/svg'
        >
          <path
            d='M16.59 9H15V4C15 3.45 14.55 3 14 3H10C9.45 3 9 3.45 9 4V9H7.41C6.52 9 6.07 10.08 6.7 10.71L11.29 15.3C11.68 15.69 12.31 15.69 12.7 15.3L17.29 10.71C17.92 10.08 17.48 9 16.59 9ZM5 19C5 19.55 5.45 20 6 20H18C18.55 20 19 19.55 19 19C19 18.45 18.55 18 18 18H6C5.45 18 5 18.45 5 19Z'
            fill={props.color ? props.color : '#000000'}
          />
        </svg>
      );
    }}
    {...props}
  />
);

const EventIcon = props => (
  <Icon
    component={() => {
      return (
        <svg
          width={props.size ? props.size : '14'}
          height={props.size ? props.size : '14'}
          viewBox='0 0 14 14'
          fill='none'
          xmlns='http://www.w3.org/2000/svg'
        >
          <path
            d='M10.6667 1.66634H10V0.333008H8.66667V1.66634H3.33333V0.333008H2V1.66634H1.33333C0.593333 1.66634 0.00666666 2.26634 0.00666666 2.99967L0 12.333C0 13.0663 0.593333 13.6663 1.33333 13.6663H10.6667C11.4 13.6663 12 13.0663 12 12.333V2.99967C12 2.26634 11.4 1.66634 10.6667 1.66634ZM10.6667 12.333H1.33333V5.66634H10.6667V12.333ZM10.6667 4.33301H1.33333V2.99967H10.6667V4.33301ZM6 7.66634H9.33333V10.9997H6V7.66634Z'
            fill={props.color ? props.color : '#FFFFFF'}
          />
        </svg>
      );
    }}
    {...props}
  />
);

const NotesIcon = props => (
  <Icon
    component={() => {
      return (
        <svg
          width={props.size ? props.size : '12'}
          height={props.size ? props.size : '12'}
          viewBox='0 0 12 12'
          fill='none'
          xmlns='http://www.w3.org/2000/svg'
        >
          <path
            d='M10.6667 1.33333V10.6667H1.33333V1.33333H10.6667ZM10.6667 0H1.33333C0.6 0 0 0.6 0 1.33333V10.6667C0 11.4 0.6 12 1.33333 12H10.6667C11.4 12 12 11.4 12 10.6667V1.33333C12 0.6 11.4 0 10.6667 0Z'
            fill={props.color ? props.color : '#FFFFFF'}
          />
          <path
            d='M7.33341 9.33366H2.66675V8.00033H7.33341V9.33366ZM9.33341 6.66699H2.66675V5.33366H9.33341V6.66699ZM9.33341 4.00033H2.66675V2.66699H9.33341V4.00033Z'
            fill={props.color ? props.color : '#FFFFFF'}
          />
        </svg>
      );
    }}
    {...props}
  />
);

const CallOutlineIcon = props => (
  <Icon
    component={() => {
      return (
        <svg
          width={props.size ? props.size : '12'}
          height={props.size ? props.size : '12'}
          viewBox='0 0 12 12'
          fill='none'
          xmlns='http://www.w3.org/2000/svg'
        >
          <path
            d='M2.36 1.33333C2.4 1.92667 2.5 2.50667 2.66 3.06L1.86 3.86C1.58667 3.06 1.41333 2.21333 1.35333 1.33333H2.36V1.33333ZM8.93333 9.34667C9.5 9.50667 10.08 9.60667 10.6667 9.64667V10.64C9.78667 10.58 8.94 10.4067 8.13333 10.14L8.93333 9.34667V9.34667ZM3 0H0.666667C0.3 0 0 0.3 0 0.666667C0 6.92667 5.07333 12 11.3333 12C11.7 12 12 11.7 12 11.3333V9.00667C12 8.64 11.7 8.34 11.3333 8.34C10.5067 8.34 9.7 8.20667 8.95333 7.96C8.88667 7.93333 8.81333 7.92667 8.74667 7.92667C8.57333 7.92667 8.40667 7.99333 8.27333 8.12L6.80667 9.58667C4.92 8.62 3.37333 7.08 2.41333 5.19333L3.88 3.72667C4.06667 3.54 4.12 3.28 4.04667 3.04667C3.8 2.3 3.66667 1.5 3.66667 0.666667C3.66667 0.3 3.36667 0 3 0Z'
            fill={props.color ? props.color : '#FFFFFF'}
          />
        </svg>
      );
    }}
    {...props}
  />
);

const DotIcon = props => (
  <Icon
    component={() => {
      return (
        <svg
          width={props.size ? props.size : '8'}
          height={props.size ? props.size : '8'}
          viewBox='0 0 8 8'
          fill='none'
          xmlns='http://www.w3.org/2000/svg'
        >
          <circle cx='4' cy='4' r='4' fill={props.color ? props.color : '#FFFFFF'} />
        </svg>
      );
    }}
    {...props}
  />
);

const SheetTemplateIcon = props => (
  <Icon
    component={() => {
      return (
        <svg width='36' height='33' viewBox='0 0 36 33' fill='none' xmlns='http://www.w3.org/2000/svg'>
          <path
            d='M7.79492 2.30908C6.69035 2.30908 5.79492 3.20451 5.79492 4.30908V29.6424C5.79492 30.747 6.69035 31.6424 7.79492 31.6424H25.1283C26.2328 31.6424 27.1283 30.747 27.1283 29.6424V10.3091L19.1283 2.30908H7.79492Z'
            fill='#20A464'
            fill-opacity='0.63'
          />
          <path
            d='M7.79492 31.6424C6.69035 31.6424 5.79492 30.747 5.79492 29.6424V29.3091C5.79492 30.4137 6.69035 31.3091 7.79492 31.3091H25.1283C26.2328 31.3091 27.1283 30.4137 27.1283 29.3091V29.6424C27.1283 30.747 26.2328 31.6424 25.1283 31.6424H7.79492Z'
            fill='#149456'
          />
          <path
            d='M7.79492 2.30908C6.69035 2.30908 5.79492 3.20451 5.79492 4.30908V4.64242C5.79492 3.53785 6.69035 2.64242 7.79492 2.64242H19.4616L19.1283 2.30908H7.79492Z'
            fill='#38AE74'
          />
          <path
            d='M27.1279 17.1421V10.3088L25.9612 9.14209H20.335C19.8895 9.14209 19.6665 9.68066 19.9814 9.99564L27.1279 17.1421Z'
            fill='url(#paint0_linear_4710_68115)'
          />
          <path d='M19.127 2.30908L27.127 10.3091H21.127C20.0224 10.3091 19.127 9.41365 19.127 8.30908V2.30908Z' fill='#8ED1B1' />
          <path
            fillRule='evenodd'
            clipRule='evenodd'
            d='M21.7936 16.6421V26.3088H11.127V16.6421H21.7936ZM15.7936 17.9754H12.4603V19.6421H15.7936V17.9754ZM17.127 19.6421V17.9754H20.4603V19.6421H17.127ZM15.7936 20.6421H12.4603V22.3088H15.7936V20.6421ZM17.127 22.3088V20.6421H20.4603V22.3088H17.127ZM15.7936 23.3088H12.4603V24.9754H15.7936V23.3088ZM17.127 24.9754V23.3088H20.4603V24.9754H17.127Z'
            fill='white'
          />
          <path
            d='M30 17C26.694 17 24 19.694 24 23C24 26.306 26.694 29 30 29C33.306 29 36 26.306 36 23C36 19.694 33.306 17 30 17ZM31.554 20.954L32.4 21.8L30 24.2L27.6 21.8L28.446 20.954L29.4 21.902V19.4H30.6V21.902L31.554 20.954ZM33 26H27V24.8H33V26Z'
            fill='#FFB200'
          />
          <defs>
            <linearGradient
              id='paint0_linear_4710_68115'
              x1='23.4809'
              y1='17.1421'
              x2='23.4809'
              y2='8.97542'
              gradientUnits='userSpaceOnUse'
            >
              <stop stop-color='#20A464' />
              <stop offset='1' stop-color='#207E55' />
            </linearGradient>
          </defs>
        </svg>
      );
    }}
    {...props}
  />
);

const SheetUploadIcon = props => (
  <Icon
    component={() => {
      return (
        <svg width='36' height='33' viewBox='0 0 36 33' fill='none' xmlns='http://www.w3.org/2000/svg'>
          <path
            d='M7.79492 2.30908C6.69035 2.30908 5.79492 3.20451 5.79492 4.30908V29.6424C5.79492 30.747 6.69035 31.6424 7.79492 31.6424H25.1283C26.2328 31.6424 27.1283 30.747 27.1283 29.6424V10.3091L19.1283 2.30908H7.79492Z'
            fill='#20A464'
            fill-opacity='0.63'
          />
          <path
            d='M30 29C33.306 29 36 26.306 36 23C36 19.694 33.306 17 30 17C26.694 17 24 19.694 24 23C24 26.306 26.694 29 30 29ZM28.446 25.046L27.6 24.2L30 21.8L32.4 24.2L31.554 25.046L30.6 24.098L30.6 26.6L29.4 26.6L29.4 24.098L28.446 25.046ZM27 20L33 20L33 21.2L27 21.2L27 20Z'
            fill='#7B61FF'
          />
          <path
            d='M7.79492 31.6424C6.69035 31.6424 5.79492 30.747 5.79492 29.6424V29.3091C5.79492 30.4137 6.69035 31.3091 7.79492 31.3091H25.1283C26.2328 31.3091 27.1283 30.4137 27.1283 29.3091V29.6424C27.1283 30.747 26.2328 31.6424 25.1283 31.6424H7.79492Z'
            fill='#149456'
          />
          <path
            d='M7.79492 2.30908C6.69035 2.30908 5.79492 3.20451 5.79492 4.30908V4.64242C5.79492 3.53785 6.69035 2.64242 7.79492 2.64242H19.4616L19.1283 2.30908H7.79492Z'
            fill='#38AE74'
          />
          <path
            d='M27.1279 17.1421V10.3088L25.9612 9.14209H20.335C19.8895 9.14209 19.6665 9.68066 19.9814 9.99564L27.1279 17.1421Z'
            fill='url(#paint0_linear_4710_68323)'
          />
          <path d='M19.127 2.30908L27.127 10.3091H21.127C20.0224 10.3091 19.127 9.41365 19.127 8.30908V2.30908Z' fill='#8ED1B1' />
          <path
            fillRule='evenodd'
            clipRule='evenodd'
            d='M21.7936 16.6421V26.3088H11.127V16.6421H21.7936ZM15.7936 17.9754H12.4603V19.6421H15.7936V17.9754ZM17.127 19.6421V17.9754H20.4603V19.6421H17.127ZM15.7936 20.6421H12.4603V22.3088H15.7936V20.6421ZM17.127 22.3088V20.6421H20.4603V22.3088H17.127ZM15.7936 23.3088H12.4603V24.9754H15.7936V23.3088ZM17.127 24.9754V23.3088H20.4603V24.9754H17.127Z'
            fill='white'
          />
          <defs>
            <linearGradient
              id='paint0_linear_4710_68323'
              x1='23.4809'
              y1='17.1421'
              x2='23.4809'
              y2='8.97542'
              gradientUnits='userSpaceOnUse'
            >
              <stop stop-color='#20A464' />
              <stop offset='1' stop-color='#207E55' />
            </linearGradient>
          </defs>
        </svg>
      );
    }}
    {...props}
  />
);

const BulkSuccessIcon = props => (
  <Icon
    component={() => {
      return (
        <svg
          width={props.size ? props.size : '24'}
          height={props.size ? props.size : '24'}
          viewBox='0 0 24 24'
          fill='none'
          xmlns='http://www.w3.org/2000/svg'
        >
          <path
            d='M23.5 17L18.5 22L15 18.5L16.5 17L18.5 19L22 15.5L23.5 17ZM6 2C5.46957 2 4.96086 2.21071 4.58579 2.58579C4.21071 2.96086 4 3.46957 4 4V20C4 21.11 4.89 22 6 22H13.81C13.45 21.38 13.2 20.7 13.08 20H6V4H13V9H18V13.08C18.33 13.03 18.67 13 19 13C19.34 13 19.67 13.03 20 13.08V8L14 2H6ZM8 12V14H16V12H8ZM8 16V18H13V16H8Z'
            fill={props.color ? props.color : '#3A6ACD'}
          />
        </svg>
      );
    }}
    {...props}
  />
);

const BulkFailedIcon = props => (
  <Icon
    component={() => {
      return (
        <svg
          width={props.size ? props.size : '24'}
          height={props.size ? props.size : '24'}
          viewBox='0 0 24 24'
          fill='none'
          xmlns='http://www.w3.org/2000/svg'
        >
          <path
            d='M20 17H22V15H20V17ZM20 7V13H22V7H20ZM6 16H11V18H6V16ZM6 12H14V14H6V12ZM4 2C2.89 2 2 2.89 2 4V20C2 21.11 2.89 22 4 22H16C17.11 22 18 21.11 18 20V8L12 2H4ZM4 4H11V9H16V20H4V4Z'
            fill={props.color ? props.color : '#C20013'}
          />
        </svg>
      );
    }}
    {...props}
  />
);

const ReplayIcon = props => (
  <Icon
    component={() => {
      return (
        <svg
          width={props.size ? props.size : '16'}
          height={props.size ? props.size : '16'}
          viewBox='0 0 16 16'
          fill='none'
          xmlns='http://www.w3.org/2000/svg'
        >
          <path
            d='M7.99994 3.33303V1.47303C7.99994 1.17303 8.35994 1.02636 8.56661 1.23969L11.0999 3.76636C11.2333 3.89969 11.2333 4.10636 11.0999 4.2397L8.57327 6.76636C8.35994 6.97303 7.99994 6.82636 7.99994 6.52636V4.66636C5.51327 4.66636 3.54661 6.94636 4.09327 9.52636C4.40661 11.0397 5.63327 12.2597 7.13994 12.573C9.51994 13.073 11.6399 11.4397 11.9599 9.23303C12.0066 8.91303 12.2866 8.66636 12.6133 8.66636C13.0133 8.66636 13.3333 9.0197 13.2799 9.4197C12.8666 12.3464 10.0799 14.513 6.92661 13.8997C4.84661 13.493 3.17327 11.8197 2.76661 9.73969C2.10661 6.31969 4.70661 3.33303 7.99994 3.33303Z'
            fill={props.color ? props.color : '#FFFFFF'}
          />
        </svg>
      );
    }}
    {...props}
  />
);

const SwitchUserIcon = props => (
  <Icon
    component={() => {
      return (
        <svg
          width={props.size ? props.size : '24'}
          height={props.size ? props.size : '24'}
          viewBox='0 0 24 24'
          fill='none'
          xmlns='http://www.w3.org/2000/svg'
        >
          <path
            d='M17.9103 7.83529C17.9103 4.61176 15.2537 2 11.9749 2C8.69608 2 6.03953 4.61176 6.03953 7.83529C6.03953 9.78353 7.01121 11.5106 8.50462 12.5694C8.49505 12.5741 8.48787 12.5765 8.48308 12.5788C7.41328 13.0235 6.45357 13.6612 5.62788 14.4753C4.8022 15.2871 4.15601 16.2329 3.70368 17.2871C3.26092 18.3176 3.02398 19.4118 3.00005 20.5365C2.99766 20.6424 3.08381 20.7294 3.19151 20.7294H4.62509C4.72801 20.7294 4.81416 20.6471 4.81656 20.5459C4.86442 18.7294 5.60395 17.0282 6.91308 15.7388C8.26529 14.4047 10.0603 13.6706 11.9749 13.6706C15.2537 13.6706 17.9103 11.0588 17.9103 7.83529ZM11.9749 11.8824C9.70127 11.8824 7.85843 10.0706 7.85843 7.83529C7.85843 5.6 9.70127 3.78824 11.9749 3.78824C14.2485 3.78824 16.0914 5.6 16.0914 7.83529C16.0914 10.0706 14.2485 11.8824 11.9749 11.8824ZM14.4879 17.0824H20.8061C20.9114 17.0824 20.9976 16.9976 20.9976 16.8941V15.5765C20.9976 15.4729 20.9114 15.3882 20.8061 15.3882H16.582L17.7116 13.9741C17.7379 13.9412 17.7523 13.8988 17.7523 13.8588C17.7523 13.7553 17.6661 13.6706 17.5608 13.6706H15.8233C15.706 13.6706 15.5959 13.7247 15.5218 13.8141L13.8823 15.8635C13.777 15.9953 13.7196 16.16 13.7196 16.3294C13.722 16.7459 14.0642 17.0824 14.4879 17.0824ZM20.2318 18.5882H13.9135C13.8082 18.5882 13.722 18.6729 13.722 18.7765V20.0941C13.722 20.1976 13.8082 20.2824 13.9135 20.2824H18.1376L17.008 21.6965C16.9817 21.7294 16.9673 21.7718 16.9673 21.8118C16.9673 21.9153 17.0535 22 17.1588 22H18.8963C19.0136 22 19.1237 21.9459 19.1979 21.8565L20.8373 19.8071C20.9426 19.6753 21 19.5106 21 19.3412C20.9976 18.9247 20.6554 18.5882 20.2318 18.5882Z'
            fill={props.color ? props.color : '#FFFFFF'}
          />
        </svg>
      );
    }}
    {...props}
  />
);

const EmailIcon = props => (
  <Icon
    component={() => {
      return (
        <svg
          xmlns='http://www.w3.org/2000/svg'
          width={props.size ? props.size : '24'}
          height={props.size ? props.size : '24'}
          viewBox='0 0 512 512'
          fill='none'
        >
          <path
            d='M440.917,67.925H71.083C31.827,67.925,0,99.752,0,139.008v233.984c0,39.256,31.827,71.083,71.083,71.083
            h369.834c39.255,0,71.083-31.827,71.083-71.083V139.008C512,99.752,480.172,67.925,440.917,67.925z M178.166,321.72l-99.54,84.92
            c-7.021,5.992-17.576,5.159-23.567-1.869c-5.992-7.021-5.159-17.576,1.87-23.567l99.54-84.92c7.02-5.992,17.574-5.159,23.566,1.87
            C186.027,305.174,185.194,315.729,178.166,321.72z M256,289.436c-13.314-0.033-26.22-4.457-36.31-13.183l0.008,0.008l-0.032-0.024
            c0.008,0.008,0.017,0.008,0.024,0.016L66.962,143.694c-6.98-6.058-7.723-16.612-1.674-23.583c6.057-6.98,16.612-7.723,23.582-1.674
            l152.771,132.592c3.265,2.906,8.645,5.004,14.359,4.971c5.706,0.017,10.995-2.024,14.44-5.028l0.074-0.065l152.615-132.469
            c6.971-6.049,17.526-5.306,23.583,1.674c6.048,6.97,5.306,17.525-1.674,23.583l-152.77,132.599
            C282.211,284.929,269.322,289.419,256,289.436z M456.948,404.771c-5.992,7.028-16.547,7.861-23.566,1.869l-99.54-84.92
            c-7.028-5.992-7.861-16.546-1.869-23.566c5.991-7.029,16.546-7.861,23.566-1.87l99.54,84.92
            C462.107,387.195,462.94,397.75,456.948,404.771z'
            fill={props.color ? props.color : '#FFFFFF'}
          />
        </svg>
      );
    }}
    {...props}
  />
);

export {
  AnalyticsIcon,
  ContactsIcon,
  ConsumersIcon,
  LeadsIcon,
  LogoWhiteIcon,
  LogoIcon,
  OpportunitiesIcon,
  SettingsIcon,
  AccountIcon,
  RoleIcon,
  MenuIcon,
  PersonIcon,
  ExpandMoreIcon,
  ExpandLessIcon,
  ColumnIcon,
  FilterIcon,
  CallIcon,
  WhatsAppIcon,
  MoreIcon,
  PermissionIcon,
  EditIcon,
  DragIcon,
  DropUpIcon,
  DropDownIcon,
  CheckFilledIcon,
  CheckIcon,
  CloseIcon,
  ExpandableDownIcon,
  ExpandableUpIcon,
  EventIcon,
  NotesIcon,
  DownloadIcon,
  CallOutlineIcon,
  DotIcon,
  SheetTemplateIcon,
  SheetUploadIcon,
  BulkSuccessIcon,
  BulkFailedIcon,
  ReplayIcon,
  SwitchUserIcon,
  EmailIcon,
};
